import { render, staticRenderFns } from "./MagazineViewer.vue?vue&type=template&id=b4df128a"
import script from "./MagazineViewer.vue?vue&type=script&lang=js"
export * from "./MagazineViewer.vue?vue&type=script&lang=js"
import style0 from "./MagazineViewer.vue?vue&type=style&index=0&id=b4df128a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports